module.exports = __webpack_public_path__ + "static/media/blog-personalization-choosing-peanut-butter.53a73bc8.jpg";